import { useEffect, useState } from "react";
import { columns } from "./columns.tsx";
import { DataTable } from "./data-table.tsx";
import * as React from "react";
import {
  collection,
  getDocs,
  limit,
  orderBy,
  query,
  startAfter,
  where,
} from "firebase/firestore";
import { db, storage } from "../../firebase/firebase";
// import "../../styleWind.css";
import {
  QueryClient,
  QueryClientProvider,
  useQuery,
} from "@tanstack/react-query";
import { getAuth, onAuthStateChanged } from "firebase/auth";

const queryClient = new QueryClient();

export default function UserPage() {
  const [data, setData] = useState() as any;
  const [isLoading, setIsloading] = useState(true);
  const [group, setGroup] = useState(null);
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    const getUser = async () => {
      const auth = await getAuth();

      onAuthStateChanged(auth, (user) => {
        if (user) {
          loadPermission(user.uid);
        } else {
          window.location.replace("/");
        }
      });
    };
    getUser();
  }, []);

  const loadPermission = async (urlVar) => {
    const q = query(collection(db, "users"), where("__name__", "==", urlVar));

    const querySnapshot = await getDocs(q);

    querySnapshot.forEach((doc) => {
      if (doc.data().isAdmin) {
        setIsAdmin(true);
      }

      setGroup(doc.data().permission_groups[0]);

      setData([]);
      setIsloading(false);
    });
  };

  return (
    <div style={{ width: "100%", backgroundColor: "000", padding: "20px" }}>
      <QueryClientProvider client={queryClient}>
        <div className="tw-container tw-mx-auto tw-py-10">
          {isLoading ? (
            <></>
          ) : (
            <DataTable
              columns={columns}
              data={data}
              group={group}
              isAdmin={isAdmin}
            />
          )}
        </div>
      </QueryClientProvider>
    </div>
  );
}
